if (typeof window !== 'undefined') {
  const intersectionObserverSupported =
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype;

  if (!intersectionObserverSupported) {
    require('intersection-observer');
  }
}
